var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 7.125H11.875V2.375C11.875 1.74511 11.6248 1.14102 11.1794 0.695621C10.734 0.250222 10.1299 0 9.5 0C8.87011 0 8.26602 0.250222 7.82062 0.695621C7.37522 1.14102 7.125 1.74511 7.125 2.375L7.20931 7.125H2.375C1.74511 7.125 1.14102 7.37522 0.695621 7.82062C0.250222 8.26602 0 8.87011 0 9.5C0 10.1299 0.250222 10.734 0.695621 11.1794C1.14102 11.6248 1.74511 11.875 2.375 11.875L7.20931 11.7907L7.125 16.625C7.125 17.2549 7.37522 17.859 7.82062 18.3044C8.26602 18.7498 8.87011 19 9.5 19C10.1299 19 10.734 18.7498 11.1794 18.3044C11.6248 17.859 11.875 17.2549 11.875 16.625V11.7907L16.625 11.875C17.2549 11.875 17.859 11.6248 18.3044 11.1794C18.7498 10.734 19 10.1299 19 9.5C19 8.87011 18.7498 8.26602 18.3044 7.82062C17.859 7.37522 17.2549 7.125 16.625 7.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusActive);
export default __webpack_public_path__ + "static/media/plus-active.1ccba0935521ddf560a9cee6673e5297.svg";
export { ForwardRef as ReactComponent };